/*
 * fn: subscribeClickaway
 *
 * Creates a subscription for a clickaway handler to watch for clickaway events
 *
 */
import { type ClickawayScopeType } from '@/defs/clickaway'

import { isClickawayIgnored } from './isClickawayIgnored'

export type ClickawaySubscriberType = {
  ignore: ClickawayScopeType | 'allScopes'
  onClickAway: () => void
}

const subscribers = new Set<ClickawaySubscriberType>()

const notify = (clickedElement: EventTarget | null) => {
  if (
    !(clickedElement instanceof Element) ||
    clickedElement === document.documentElement ||
    window.getComputedStyle(document.body).pointerEvents === 'none'
  ) {
    return
  }

  for (const subscriber of [...subscribers]) {
    if (!isClickawayIgnored(clickedElement, subscriber.ignore)) subscriber.onClickAway()
  }
}

const onMouseDown = (e: MouseEvent) => notify(e.target)

export const subscribeClickaway = (subscriber: ClickawaySubscriberType) => {
  if (subscribers.size === 0) {
    window.addEventListener('mousedown', onMouseDown)
  }

  subscribers.add(subscriber)

  return () => {
    subscribers.delete(subscriber)

    if (subscribers.size === 0) {
      window.removeEventListener('mousedown', onMouseDown)
    }
  }
}
